module.exports = __webpack_public_path__ + "static/media/laurenminointeriors - 1.82cf22fd.jpg";